import React from 'react'

import classes from './layout.css'
import Checkbox from '../Fields/Checkbox'

const ModuleThirtyTwo = (props) => {
	return (
		<div>
			<h3>ANESTHESIA</h3>
			<div className={classes.ListItem}>
				<Checkbox
					controlFunc={props.addToForm}
					name={"anesthesia1"}
					value={props.consentForm.anesthesia1}
				/>
				The following types of anesthesia have been explained to me. My doctor has explained and I understand the risks and benefits of each one. The one I have chosen for my surgery is:
			</div>
			<div className={classes.Anesthesia}>
				<Checkbox 
					name={"anesthesia1Options"}
					id={"1"}
					controlFunc={props.addToForm}
					value={props.consentForm.anesthesia1Options[1]}
				/>Local Anesthesia<br/>

				<Checkbox
					name={"anesthesia1Options"}
					controlFunc={props.addToForm}
					id={"2"}
					value={props.consentForm.anesthesia1Options[2]}
				/>Local Anesthesia with Nitrous Oxide/Oxygen Analgesia<br />

				<Checkbox
					name={"anesthesia1Options"}
					controlFunc={props.addToForm}
					id={"3"}
					value={props.consentForm.anesthesia1Options[3]}
				/>Local Anesthesia with Oral Premedication<br />

				<Checkbox
					name={"anesthesia1Options"}
					controlFunc={props.addToForm}
					id={"4"}
					value={props.consentForm.anesthesia1Options[4]}
				/>Local Anesthesia with Intravenous (IV) Sedation<br />

				<Checkbox
					name={"anesthesia1Options"}
					controlFunc={props.addToForm}
					id={"5"}
					value={props.consentForm.anesthesia1Options[5]}
				/>Local Anesthesia with General Anesthesia
			</div>
			<Checkbox
				controlFunc={props.addToForm}
				name={"anesthesia2"}
				value={props.consentForm.anesthesia2}
			/>
			Anesthetic risks include: discomfort, swelling, bruising, infection, numbness for a long time and allergic reactions. There may be inflammation at the site of an intravenous (IV) injection (phlebitis) that may cause discomfort and/or disability for a long time and may require special care. Nausea and vomiting, although rare, may be unfortunate side effects of any anesthesia. Nausea and vomiting may cause increased risk when jaws are wired together. Conscious sedation and general anesthesia are serious medical procedures and, although considered safe, carry the risk of heart irregularities, heart attack, stroke, brain damage and death.
		</div>
	)
}

export default ModuleThirtyTwo


// WEBPACK FOOTER //
// ./src/components/Modules/31.js